class LocalStorageCache {
    private prefix: string;

    constructor(prefix: string = 'cache_') {
        this.prefix = prefix;
    }

    /**
     * Set a value in the cache
     * @param key The key to store the value under
     * @param value The value to store
     * @param ttl Time to live in seconds
     */
    set(key: string, value: any, ttl: number = 30): void {
        const prefixedKey = this.prefix + key;
        const expiresAt = ttl ? Date.now() + (ttl * 1e3) : null;
        const item = {
            value,
            expiresAt
        };
        const stringValue = JSON.stringify(item);
        localStorage.setItem(prefixedKey, stringValue);
    }

    has(key: string): boolean {
        const prefixedKey = this.prefix + key;
        return localStorage.getItem(prefixedKey) !== null;
    }

    get<T>(key: string): T | null {
        const prefixedKey = this.prefix + key;
        const stringValue = localStorage.getItem(prefixedKey);
        if (stringValue) {
            const item = JSON.parse(stringValue);
            if (item.expiresAt && Date.now() > item.expiresAt) {
                localStorage.removeItem(prefixedKey);
                return null;
            }
            return item.value as T;
        }
        return null;
    }

    removeItem(key: string): void {
        const prefixedKey = this.prefix + key;
        localStorage.removeItem(prefixedKey);
    }

    clear(): void {
        Object.keys(localStorage)
            .filter(key => key.startsWith(this.prefix))
            .forEach(key => localStorage.removeItem(key));
    }

    clearExpired(): void {
        Object.keys(localStorage)
            .filter(key => key.startsWith(this.prefix))
            .forEach(key => {
                const stringValue = localStorage.getItem(key);
                if (stringValue) {
                    const item = JSON.parse(stringValue);
                    if (item.expiresAt && Date.now() > item.expiresAt) {
                        localStorage.removeItem(key);
                    }
                }
            });
    }
}

export const cache = new LocalStorageCache('pwcache_');

